// extracted by mini-css-extract-plugin
module.exports = {"createUser":"CreateUser_createUser__3XbBB","errors":"CreateUser_errors__3fU7w"};